module.exports = __webpack_public_path__ + "static/media/soles_logo.333c8c61.png";